export default "__VITE_ASSET__DiQ45EnJ__"